// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1213":"b87d0620","7316":"749902f7","7524":"3e4f4554"}[chunkId] + ".chunk.css";
};